import React, { useState, useEffect } from 'react'
import { serbaUsahaService } from '../../services/serbaUsahaService'

function Pengaturan() {
  const [form, setForm] = useState({
    TipeBunga: 'Efektif', BungaPerBulan: 0, DendaPerBulan: 0, TenorDefault: 3,
    KodeAkunPiutang: '1107', KodeAkunPendapatan: '4500', KodeAkunBunga: '4501',
    KodeAkunPersediaan: '1108', KodeAkunHPP: '5110'
  })
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    fetchSettings()
  }, [])

  const fetchSettings = async () => {
    try {
      setLoading(true)
      const res = await serbaUsahaService.getSettings()
      if (res.data.data) {
        const s = res.data.data
        setForm({
          TipeBunga: s.TipeBunga || 'Efektif',
          BungaPerBulan: s.BungaPerBulan || 0,
          DendaPerBulan: s.DendaPerBulan || 0,
          TenorDefault: s.TenorDefault || 3,
          KodeAkunPiutang: s.KodeAkunPiutang || '1107',
          KodeAkunPendapatan: s.KodeAkunPendapatan || '4500',
          KodeAkunBunga: s.KodeAkunBunga || '4501',
          KodeAkunPersediaan: s.KodeAkunPersediaan || '1108',
          KodeAkunHPP: s.KodeAkunHPP || '5110'
        })
      }
    } catch (err) { console.error(err) }
    finally { setLoading(false) }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSaving(true)
    try {
      await serbaUsahaService.updateSettings(form)
      alert('Pengaturan berhasil disimpan')
    } catch (err) { alert('Gagal: ' + (err.response?.data?.message || err.message)) }
    finally { setSaving(false) }
  }

  if (loading) return <div className="text-center py-5"><i className="fas fa-spinner fa-spin fa-3x"></i></div>

  return (
    <div className="card">
      <div className="card-header"><h3 className="card-title">Pengaturan Serba Usaha</h3></div>
      <div className="card-body">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6">
              <h5>Bunga & Denda</h5>
              <div className="form-group">
                <label>Tipe Bunga</label>
                <select className="form-control" value={form.TipeBunga} onChange={e => setForm({...form, TipeBunga: e.target.value})}>
                  <option value="Efektif">Efektif (Menurun)</option>
                  <option value="Flat">Flat</option>
                </select>
              </div>
              <div className="form-group">
                <label>Bunga per Bulan (%)</label>
                <input type="number" step="0.01" className="form-control" value={form.BungaPerBulan}
                  onChange={e => setForm({...form, BungaPerBulan: e.target.value})} />
                <small className="text-muted">0 = non-aktif (gunakan HargaKredit)</small>
              </div>
              <div className="form-group">
                <label>Denda per Bulan (%)</label>
                <input type="number" step="0.01" className="form-control" value={form.DendaPerBulan}
                  onChange={e => setForm({...form, DendaPerBulan: e.target.value})} />
              </div>
              <div className="form-group">
                <label>Tenor Default (bulan)</label>
                <input type="number" className="form-control" value={form.TenorDefault}
                  onChange={e => setForm({...form, TenorDefault: e.target.value})} min="1" />
              </div>
            </div>
            <div className="col-md-6">
              <h5>Kode Akun (COA)</h5>
              <div className="form-group">
                <label>Piutang Serba Usaha</label>
                <input className="form-control" value={form.KodeAkunPiutang}
                  onChange={e => setForm({...form, KodeAkunPiutang: e.target.value})} />
              </div>
              <div className="form-group">
                <label>Pendapatan Serba Usaha</label>
                <input className="form-control" value={form.KodeAkunPendapatan}
                  onChange={e => setForm({...form, KodeAkunPendapatan: e.target.value})} />
              </div>
              <div className="form-group">
                <label>Pendapatan Bunga Serba Usaha</label>
                <input className="form-control" value={form.KodeAkunBunga}
                  onChange={e => setForm({...form, KodeAkunBunga: e.target.value})} />
              </div>
              <div className="form-group">
                <label>Persediaan Barang</label>
                <input className="form-control" value={form.KodeAkunPersediaan}
                  onChange={e => setForm({...form, KodeAkunPersediaan: e.target.value})} />
              </div>
              <div className="form-group">
                <label>HPP Serba Usaha</label>
                <input className="form-control" value={form.KodeAkunHPP}
                  onChange={e => setForm({...form, KodeAkunHPP: e.target.value})} />
              </div>
            </div>
          </div>
          <div className="text-center mt-4">
            <button type="submit" className="btn btn-primary btn-lg" disabled={saving}>
              {saving ? <i className="fas fa-spinner fa-spin"></i> : 'Simpan Pengaturan'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
export default Pengaturan
